// Store tag
// Dropdown toggle
let storeTags = document.querySelectorAll(".store-tag--dropdown");

document.addEventListener("click", (e) => {
  if (e.target.closest(".store-tag--dropdown")) {
    let storeButton = e.target
      .closest(".store-tag--dropdown")
      .querySelector(".store-tag__button");
    let storeWrapper = e.target.closest(".store-tag--dropdown");
    storeWrapper.classList.toggle("open");

    if (storeWrapper.classList.contains("open")) {
      storeButton.querySelector("span").textContent = "Close Details";
    } else {
      storeButton.querySelector("span").textContent = "See Details";
    }
  }
});
